import { TrackOccupationsResponse } from "@opstel/gen/knop/ui/v1/api/sbd_pb";
import {
  OccupationsForTrack,
  occupationsForTrackSchema,
  ParsedOccupationsForTrack,
} from "../models/occupationsForTrack";
import { ZodOutputFor } from "../zod-utils";
import { z } from "zod/v3";
import { PlainMessage } from "@bufbuild/protobuf";
import {
  BlockedInfrastructures,
  blockedInfrastructuresSchema,
} from "@opstel/query/models/blockedInfrastructures";
import { DisplayConfiguration, displayConfigurationSchema } from "../models/displayConfiguration";
import { TrackGroup, trackGroupSchema } from "../models/trackGroup";

export interface SBDData extends ParsedSBDData {
  trackOccupations: OccupationsForTrack[];
}
interface ParsedSBDData {
  trackOccupations: ParsedOccupationsForTrack[];
  blockedInfrastructures: BlockedInfrastructures[];
  displayConfigurationByTrackCode: Record<string, DisplayConfiguration>;
  trackGroups: TrackGroup[];
}

const sbdDataSchema = z
  .object({
    trackOccupations: z.array(occupationsForTrackSchema),
    blockedInfrastructures: z.array(blockedInfrastructuresSchema),
    displayConfigurationByTrackCode: z.record(z.string(), displayConfigurationSchema),
    trackGroups: z.array(trackGroupSchema),
  })
  .transform((sbdData) => ({
    blockedInfrastructures: sbdData.blockedInfrastructures,
    trackOccupations: sbdData.trackOccupations.map((occupation) =>
      OccupationsForTrack.postProcess(occupation, {
        blockedInfrastructures: sbdData.blockedInfrastructures,
      }),
    ),
    displayConfigurationByTrackCode: sbdData.displayConfigurationByTrackCode,
    trackGroups: sbdData.trackGroups,
  })) satisfies ZodOutputFor<SBDData>;

export function parseSbdData(proto: PlainMessage<TrackOccupationsResponse>): SBDData {
  return sbdDataSchema.parse(proto);
}
